export const BUILD_ID = 'acc279de-390e-487c-8da8-ba6c556531c6';
export const ENV = 'dev';
